document.addEventListener('DOMContentLoaded', function () {
    const tabsItems = document.querySelectorAll('.tabs-item');
    const tabsProductsLists = document.querySelectorAll('.tabs-products-list');

    tabsItems.forEach(item => {
        item.addEventListener('click', function () {
            const collection = item.getAttribute('data-collection');

            // Hide all product lists
            tabsProductsLists.forEach(list => {
                list.style.display = 'none';
            });

            // Show the selected product list
            const activeList = document.querySelector(`.tabs-products-list[data-handle="${collection}"]`);
            if (activeList) {
                activeList.style.display = 'grid';
            }
        });
    });
});
